export default {
  init() {
    // JavaScript to be fired on the about us page
    $('.tab-container').children('a').click(function (){
      var classes = $(this).attr('class');
      var idArray = classes.split(' ');

      var idName = idArray[0];

      //Add active to the answers class to toggle divs
        $(this).siblings().removeClass('active');
        $(this).addClass('active');


        $('.tab-content-container').children('.tab-content').children('div').addClass('hidden');
        $('.tab-content-container').children('.tab-content').find('#'+idName).removeClass('hidden');


    });

    $('.next-link').click(function (){
      var classes = $(this).attr('class');
      var idArray = classes.split(' ');

      var idName = idArray[1];

      console.log(idName, 'next-click');
      //Add active to the answers class to toggle divs

      $('.tab-container').children('a').removeClass('active');
      $('.tab-container').find('a.' + idName).addClass('active');

      $(this).parents('.tab-content').children('div').addClass('hidden');
      $(this).parents('.tab-content').find('#'+idName).removeClass('hidden');


    });

    $('.question').click(function (){
      var classes = $(this).attr('class');
      var idArray = classes.split(' ');

      var idName = idArray[1];

      $('.tab-container').children('a').removeClass('active');
      $('.tab-container').find('a.' + idName).addClass('active');

      $('.tab-content-container').children('.tab-content').children('div').addClass('hidden');
      $('.tab-content-container').children('.tab-content').find('#'+idName).removeClass('hidden');

      $('html, body').animate({ scrollTop: $('#about-overview').offset().top }, 500);

    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js